import { AIOT_ODD_CASE } from 'constant'
import { ChartType, InputDataProps } from '../types'
import { getMetricData } from './getDataAIMetricsOT'

export function getCheckedHaveData(
  metricList: any[] | undefined,
  csvData: any,
  currentCountry: string,
  chartType: ChartType,
) {
  const isGlobal = currentCountry === 'Global'
  const isBarChart = chartType === 'bar'
  if (!metricList) {
    return []
  }
  return metricList?.map((metricItem) => {
    const metricKey = Object.keys(metricItem)[0]
    const metricDisplayName = metricItem[metricKey]

    // Call getMetricData for each metric
    const dataAIMetricOT = getMetricData(csvData, metricKey, currentCountry)
    // Check if there is data and calculate if isNoData ot not
    let isNoData = dataAIMetricOT?.every((item: InputDataProps) => item.value === 0)

    if (isBarChart && AIOT_ODD_CASE.includes(Object.keys(metricItem)?.[0])) {
      isNoData = true
    }

    // Return the result for the current metric
    return {
      [metricKey]: metricDisplayName,
      isNoData: isGlobal ? false : isNoData || false, // If data is undefined, default to false
      metricKey,
    }
  })
}
